(function () {
  function updateVariantBadges(container, variantId) {
    container.querySelectorAll('[data-variant-badge]').forEach(function (badge) {
      var show = variantId && badge.getAttribute('data-variant-badge') === String(variantId);
      badge.classList.toggle('product-metafield-badge--variant-hidden', !show);
      badge.hidden = !show;
    });
  }

  function isValidVariantId(variantId) {
    return variantId && variantId !== 'not-selected' && variantId !== 'unavailable';
  }

  function bindVariantBadges(container) {
    if (container.dataset.badgesBound === 'true') return;

    var productDetails = container.closest('[data-product-details]');
    if (!productDetails) return;

    var variantSelection = productDetails.querySelector('variant-selection');
    if (!variantSelection) return;

    container.dataset.badgesBound = 'true';

    function syncFromVariantSelection() {
      var variantId = variantSelection.getAttribute('variant');
      var mainEl = variantSelection.querySelector('[data-variants]');

      if (!isValidVariantId(variantId) && mainEl) {
        variantId = mainEl.value;
      }

      updateVariantBadges(container, isValidVariantId(variantId) ? variantId : null);
    }

    variantSelection.addEventListener('variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      updateVariantBadges(container, variant ? variant.id : null);
    });

    var variantObserver = new MutationObserver(syncFromVariantSelection);
    variantObserver.observe(variantSelection, {
      attributes: true,
      attributeFilter: ['variant']
    });

    var mainEl = variantSelection.querySelector('[data-variants]');
    if (mainEl) {
      mainEl.addEventListener('change', syncFromVariantSelection);
    }

    productDetails.addEventListener('change', function (event) {
      if (event.target.closest('[data-variant-option]')) {
        window.requestAnimationFrame(syncFromVariantSelection);
      }
    });

    productDetails.addEventListener('click', function (event) {
      if (event.target.closest('[data-variant-option-value]')) {
        window.requestAnimationFrame(syncFromVariantSelection);
      }
    });

    syncFromVariantSelection();
  }

  function initProductMetafieldBadges() {
    document.querySelectorAll('[data-product-metafield-badges]').forEach(bindVariantBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMetafieldBadges);
  } else {
    initProductMetafieldBadges();
  }
})();
